import { Component, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { Router, ActivatedRoute,Params } from '@angular/router';
import { SfIcdInfoComponent } from '../sf-icd-info/sf-icd-info.component';
import { AlertService, MessageSeverity, DialogType } from '../../services/alert.service';
import { ICD, MasterConfig, ResponseAPI, ErrorList, ICDStep2 } from '../../models/IDPReport.model';
import { SfDataService } from '../../services/sf-data.service';
import { AgentService } from '../../services/agent.service';
@Component({
    selector: 'app-sf-icd-detail',
    templateUrl: './sf-icd-detail.component.html',
    styleUrls: ['./sf-icd-detail.component.scss'],
    standalone: false
})
export class SfIcdDetailComponent implements OnInit, AfterViewInit {
  //childData: any = {};
  icd = new ICDStep2();
  formName = '';
  isByaccount = '';
  isLoading = false;
  activeTab = 2;
  caseSummary: string | null = null;
  summaryLoading = false;
  @ViewChild(SfIcdInfoComponent) childComponent!: SfIcdInfoComponent;
  id: string; f: string; d: string;
    selectedCountry: string;

  activateTab(tabIndex: number) {
    this.activeTab = tabIndex;
  }


  constructor(private route: ActivatedRoute, public router: Router, private alertService: AlertService, private sfDataService: SfDataService, private agentService: AgentService) { }

  ngOnInit(): void {
    
    this.route.firstChild.params.subscribe((params: Params) => {
      this.id = params['id'];


      const q = params['query'];


      this.f = params['f'];// this.route.snapshot.paramMap.get('f');

      this.d = params['dcode'];// this.route.snapshot.paramMap.get('dcode');

      if (this.id != null) {
        
        
          this.BindData(this.id);
        
        //if (q != null ) {

        //}
        //else {
          
        //  this.BindData(this.id);
        //}

      } 
    });
  
    this.activateTab(2);
  }

  ngAfterViewInit() {
    //this.childData = this.childComponent.icd_o;
  }

  receiveDataFromChild(id: string) {
    ////console.log('parent');
    ////console.log(id);
    // do something with the id parameter value here
  }

  // Normalizes a stored campaigns string for display: drops empty entries (which
  // otherwise show as a leading comma) and separates campaigns with ", ".
  private formatCampaigns(campaigns: string): string {
    if (!campaigns) { return campaigns; }
    return campaigns
      .split(',')
      .map(item => item.trim())
      .filter(item => item.length > 0)
      .join(', ');
  }

  private mapDataToICD(data: any) {

    if (data == null) {

      
      this.alertService.showMessage('ICD', `This Case is not assigned to view`, MessageSeverity.error);
      this.alertService.startLoadingMessage('', 'This Case is not assigned to view');
      this.alertService.showStickyMessage('ICD', 'This Case is not assigned to view', MessageSeverity.error, "");
      

      return;
    }
    this.icd.US_or_CA = data.uS_or_CA;
    this.selectedCountry = data.uS_or_CA;
    
    this.icd.Owner_First_Name = data.owner_First_Name;
    this.icd.Owner_Last_Name = data.owner_Last_Name;
    this.icd.Owner_Name = data.owner_Name;
    this.icd.Full_Legal_Company_Name = data.full_Legal_Company_Name;
    this.icd.Tax_ID = data.tax_ID;
    this.icd.State_of_Incorporation = data.state_of_Incorporation;
    this.icd.Campaigns = this.formatCampaigns(data.campaigns);
    this.icd.Provinence_of_Incorporation = data.provinence_of_Incorporation;
    this.icd.Date_of_Incorporation = data.date_of_Incorporation;
    this.icd.Mobile_Phone = data.mobile_Phone;
    this.icd.Legal_Email = data.legal_Email;
    ////console.log(data)
    this.generateCaseSummary();
  }

  private generateCaseSummary(): void {
    this.summaryLoading = true;
    this.caseSummary = null;
    const snapshot: Record<string, string> = {
      Full_Legal_Company_Name: this.icd.Full_Legal_Company_Name ?? '',
      Owner_First_Name: this.icd.Owner_First_Name ?? '',
      Owner_Last_Name: this.icd.Owner_Last_Name ?? '',
      US_or_CA: this.icd.US_or_CA ?? '',
      Tax_ID: this.icd.Tax_ID ?? '',
      State_of_Incorporation: this.icd.State_of_Incorporation ?? '',
      Provinence_of_Incorporation: this.icd.Provinence_of_Incorporation ?? '',
      Date_of_Incorporation: this.icd.Date_of_Incorporation ?? '',
      Campaigns: this.icd.Campaigns ?? '',
      Legal_Email: this.icd.Legal_Email ?? '',
      Mobile_Phone: this.icd.Mobile_Phone ?? '',
    };
    this.agentService.getCaseSummary(snapshot).subscribe({
      next: res => {
        this.caseSummary = res.summary;
        this.summaryLoading = false;
      },
      error: () => {
        this.summaryLoading = false;
      }
    });
  }

  BindData(id: string) {
    //debugger;

    this.isLoading = true;
    this.alertService.startLoadingMessage('', 'Data loading...');
    //this.icd.Owner_Email = this.icdForm.value["Owner_email"];
    if (this.f != null && this.d != null) {
      this.sfDataService.getICDStep3byAcc(id)
        .subscribe(
          data => {
            ////console.log(data);
            //debugger;
            this.isByaccount = 'Yes';
            this.formName = this.f;
            this.mapDataToICD(data);


            this.alertService.stopLoadingMessage();
          },
          error => {

            this.alertService.stopLoadingMessage();


            setTimeout(() => {
              this.isLoading = false;
            }, 500);
          });
    }
    else {
      this.sfDataService.getICD(id)
        .subscribe(
          data => {
            ////console.log(data);
            //debugger;
            this.isByaccount = 'No';
            this.mapDataToICD(data);


            this.alertService.stopLoadingMessage();
          },
          error => {

            this.alertService.stopLoadingMessage();


            setTimeout(() => {
              this.isLoading = false;
            }, 500);
          });
    }
   
  }
  

   
}
